<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "UserList" });
import * as API from "../../services/api.js";
import { USER_STORE, USER_HASH } from "../../services/store.js";
import { onDestroy, onMount } from "svelte";
import { get, writable, derived } from "svelte/store";
export let parameters;
const STORE = writable([]);
let unsubscribe;
let isLoading = false;
let previousParams = "";
let previousHash = $USER_HASH;
const syncFromGlobalStore = (data) => {
    const USERS = get(STORE).map((user) => {
        const KEY = user._.key;
        if (!(KEY in data)) {
            return user;
        }
        return data[KEY];
    });
    STORE.set(USERS);
};
const setStore = (users) => {
    STORE.set(users);
    isLoading = false;
};
const onParametersChange = (parameters2) => {
    const CURRENT_PARAMS = JSON.stringify(parameters2);
    if (CURRENT_PARAMS === previousParams) {
        return;
    }
    previousParams = CURRENT_PARAMS;
    isLoading = true;
    void API.filterUsers({ ...parameters2 }).then(setStore);
};
$: onParametersChange(parameters);
const onUserHashChange = (hash) => {
    if (hash === previousHash) {
        return;
    }
    previousHash = $USER_HASH;
    isLoading = true;
    void API.filterUsers({ ...parameters }).then(setStore);
};
$: onUserHashChange($USER_HASH);
onMount(() => {
    unsubscribe = USER_STORE.subscribe(syncFromGlobalStore);
});
onDestroy(() => {
    if (unsubscribe !== void 0) {
        unsubscribe();
    }
});
export const COUNT = derived(STORE, ($STORE) => $STORE.length);
</script>

{#if isLoading}
    <slot name = 'loading'/>
{:else if Array.isArray($STORE) && $STORE.length > 0}
    <slot users = { $STORE }>
        <pre>{ JSON.stringify($STORE, null, 4) }</pre>
    </slot>
{:else}
    <slot name = 'empty' />
{/if}